<template>
  <div class="big">
    <div class="page_title">分销订单结算</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="border-bottom: 1px solid #e8e9f0">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              index="1"
              class="title"
            >待结算</el-menu-item>
            <el-menu-item
              index="2"
              class="title"
              :disabled="
                  module_id_array[0] ? !module_id_array.includes('999') : false
                "
            >已结算</el-menu-item>
            <el-menu-item
              index="3"
              class="title"
              :disabled="
                  module_id_array[0] ? !module_id_array.includes('1000') : false
                "
            >核算中</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <keep-alive>
              <component :is="currentComponent" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PreSettlement from './PreSettlement';
import Settled from './Settled';
import SettleIng from './SettleIng.vue';

export default {
  data() {
    return {
      activeIndex: '1',
      active: ''
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return PreSettlement;
        case '2':
          return Settled;
        case '3':
          return SettleIng;
        default:
          return PreSettlement;
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}

.title {
  font-size: 16px;
}
</style>
